export default __webpack_public_path__ + "static/media/NC_1024x1024.67489b22.png";